import { Button, Tooltip } from "@mui/material"
import {
  LoadingButton,
  useQueryClient,
  useRoleConf,
} from "@pharmupp/p3-front-commons"
import { useState } from "react"
import { JustifyModal } from "../../../JustifyModal"
import { adhMarketingOPApiRoleConf } from "../../conf"
import {
  useAdhMarketingOPDisplayApi,
  useSubscriptionApi,
} from "../useAdhMarketingOPDisplayApi"

export const SubscribeButton = ({
  operationId,
  disabled,
  hidden,
}: {
  operationId: string
  disabled?: boolean
  hidden?: boolean
}) => {
  if (disabled)
    return (
      <Tooltip title="L'inscription ne sera possible que lorsque l'opération aura démarré">
        <span>
          <LoadingSubscribeButton
            operationId={operationId}
            hidden={hidden}
            disabled
          />
        </span>
      </Tooltip>
    )
  return <LoadingSubscribeButton operationId={operationId} hidden={hidden} />
}

const LoadingSubscribeButton = ({
  operationId,
  disabled,
  hidden,
}: {
  operationId: string
  disabled?: boolean
  hidden?: boolean
}) => {
  const { subscribe, isSubscribing } = useSubscriptionApi({ operationId })

  if (!subscribe) return null

  return (
    <LoadingButton
      variant={hidden ? "outlined" : "contained"}
      onClick={() => subscribe()}
      loading={isSubscribing}
      disabled={disabled}
    >
      S&apos;inscrire
    </LoadingButton>
  )
}

export const UnsubscribeButton = ({ operationId }: { operationId: string }) => {
  const { unsubscribe, isUnsubscribing } = useSubscriptionApi({ operationId })

  if (!unsubscribe) return null

  return (
    <LoadingButton
      variant="contained"
      onClick={() => unsubscribe()}
      loading={isUnsubscribing}
    >
      Se désinscrire
    </LoadingButton>
  )
}

export const SubmitDocumentsButton = ({
  operationId,
  children,
}: {
  operationId: string
  children: string
}) => {
  const [modalOpened, setModalOpened] = useState(false)
  const { readQueryKey = [] } = useRoleConf(
    adhMarketingOPApiRoleConf(undefined, operationId),
  )

  const queryClient = useQueryClient()
  const { operation } = useAdhMarketingOPDisplayApi({
    operationId,
    enabled: modalOpened,
  })

  return (
    <>
      {/* CTA */}
      <Button
        variant="contained"
        onClick={() => setModalOpened(true)}
        sx={{ bgcolor: "common.darkBlue" }}
      >
        {children}
      </Button>

      {/* MODAL */}
      {modalOpened && (
        <JustifyModal
          open
          onClose={() => setModalOpened(false)}
          onSuccess={() => {
            queryClient.invalidateQueries({ queryKey: readQueryKey })
          }}
          operationId={operationId}
          {...(operation
            ? {
                loading: false,
                operation: {
                  name: operation.name,
                  minFiles: operation.nbProofDocumentsMin,
                  maxFiles: operation.nbProofDocumentsMax,
                  nbProofDocuments: operation.nbProofDocuments,
                  nbAmmProducts: operation.nbAmmProducts,
                },
              }
            : { loading: true })}
        />
      )}
    </>
  )
}
